import angular from "angular";

angular
    .module('Citizenship', [])
    .service('Citizenship', ['$http', function ($http) {

        function uri(key, path) {
            let link = '/control-panel/citizenships';
            if (key) {
                link += '/' + key;
            }
            if (path) {
                link += '/' + path;
            }
            return link;
        }

        this.getList = function (params) {
            return $http.get(uri(null, 'get-list'), {params: params});
        };

        this.store = function (params) {
            return $http.post(uri(), params)
        };

        this.update = function (id, params) {
            params['_method'] = 'PUT';
            return $http.post(uri(id), params);
        };

        this.destroy = function (id) {
            return $http.post(uri(id), {'_method': 'DELETE'});
        };

    }]);

export default 'Citizenship';


// WEBPACK FOOTER //
// ./resources/assets/modules/citizenships-control/citizenship.js